module.exports = __webpack_public_path__ + "img/pic-map.4e2466ed.png";